import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Apply() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 sm:pt-40 lg:pt-56 pb-12 sm:pb-16 lg:pb-20 px-4 sm:px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            Apply for Access
          </h1>
          <p className="text-base sm:text-lg text-gray-600">
            Access is intentionally limited. Complete the form below to begin the application process.
          </p>
        </div>
      </section>

      {/* Application Form */}
      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-2xl mx-auto">
          <div className="bg-gray-50 p-6 sm:p-8 lg:p-10 rounded-2xl">
            <p className="text-center text-gray-700 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
              Application form coming soon. For immediate inquiries, please contact us directly.
            </p>
            <div className="text-center">
              <a 
                href="mailto:access@halvera.com" 
                className="inline-block px-7 sm:px-8 py-3 sm:py-3.5 bg-red-600 text-white text-sm font-medium rounded-md hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
